import { css } from '@emotion/css';

interface Params {
  itemsPerRow: number;
  itemSpacing: number;
}

export const rowContainerStyles = ({ itemsPerRow, itemSpacing }: Params) => css`
  > * {
    max-width: calc((100% - ${(itemsPerRow - 1) * itemSpacing}px) / ${itemsPerRow});
  }

  > * + * {
    margin-inline-start: ${itemSpacing}px;
  }
`;
